import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function getStatusBadgeClass(status) {
  const statusMap = {
    new: "bg-muted text-foreground",
    cv_received: "bg-blue-50 text-blue-800 border border-blue-200",
    analyzed: "bg-sky-50 text-sky-800 border border-sky-200",
    rejected: "bg-rose-50 text-rose-800 border border-rose-200",
    prequalified: "bg-purple-50 text-purple-800 border border-purple-200",
    to_call: "bg-amber-50 text-amber-800 border border-amber-200",
    interviewed: "bg-indigo-50 text-indigo-800 border border-indigo-200",
    test_sent: "bg-cyan-50 text-cyan-800 border border-cyan-200",
    test_passed: "bg-teal-50 text-teal-800 border border-teal-200",
    test_failed: "bg-red-50 text-red-800 border border-red-200",
    validated: "bg-emerald-50 text-emerald-800 border border-emerald-200",
    assigned: "bg-[hsl(var(--accent))] text-[hsl(var(--primary))] border border-[hsl(var(--brand-700))]/20",
    archived: "bg-gray-50 text-gray-600 border border-gray-200",
  };
  return statusMap[status] || statusMap.new;
}

export function getStatusLabel(status) {
  const labels = {
    new: "New",
    cv_received: "CV Received",
    analyzed: "Analyzed",
    rejected: "Rejected",
    prequalified: "Prequalified",
    to_call: "To Call",
    interviewed: "Interviewed",
    test_sent: "Test Sent",
    test_passed: "Test Passed",
    test_failed: "Test Failed",
    validated: "Validated",
    assigned: "Assigned",
    archived: "Archived",
  };
  return labels[status] || status;
}